import { DefaultDeviceController } from 'amazon-chime-sdk-js';

export const resolveDeviceId = async (device) => {
  if (!device) {
    return '';
  }

  try {
    let intrinsic = device;
    if (typeof device.intrinsicDevice === 'function') {
      intrinsic = await device.intrinsicDevice();
    }
    const id = DefaultDeviceController.getIntrinsicDeviceId(intrinsic);
    return typeof id === 'string' ? id : '';
  } catch (_e) {
    return typeof device === 'string' ? device : (device?.deviceId || '');
  }
};
